import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import MatchTypeEditor from '@/common/components/MatchTypeEditor/MatchTypeEditor'

import { getValueForCategory } from './helpers'

const CriterionFields = ({
  propertyOptions,
  matchTypeOptions,
  criterion,
  onChangeField,
  onChangeMatchType,
  onChangeValue,
  onChangeMatchCase,
  onChangeMatchCurrency,
  disabled,
  showCombo,
  comboItems,
  hierarchical,
  hasError,
  currencies,
  storeCurrencyCode,
  inputBackgroundColor,
  propertyDescription,
}) => {
  const { t } = useTranslation()

  const fieldError = hasError && !criterion.field
  const matchTypeError = hasError && criterion.field && !criterion.match_type

  const propertyHelperText = propertyDescription ? t(propertyDescription) : ' '

  const handleFieldChange = e => onChangeField(e.target.value)

  return (
    <>
      <ComboBox
        label={t('Propiedad')}
        menuItems={propertyOptions}
        handleChange={handleFieldChange}
        value={criterion.field || ''}
        fullWidth
        disabled={disabled}
        backgroundColor={inputBackgroundColor}
        error={fieldError}
        helperText={fieldError ? t('Este campo es obligatorio') : propertyHelperText}
      />
      {criterion.field && (
        <MatchTypeEditor
          matchType={criterion.match_type || null}
          field={criterion.field}
          matchTypeOptions={matchTypeOptions}
          onChangeMatchType={onChangeMatchType}
          value={getValueForCategory(criterion)}
          onChange={onChangeValue}
          matchCase={criterion.match_case}
          onChangeMatchCase={onChangeMatchCase}
          disabled={disabled}
          showCombo={showCombo}
          comboItems={comboItems}
          hierarchical={hierarchical}
          inputBackgroundColor={inputBackgroundColor}
          hasError={hasError && !matchTypeError}
          matchTypeError={matchTypeError}
          matchCurrency={criterion.match_currency}
          onChangeMatchCurrency={onChangeMatchCurrency}
          currencies={currencies}
          storeCurrencyCode={storeCurrencyCode}
          selectableCurrency
        />
      )}
    </>
  )
}

export default CriterionFields
